import { render } from "./DownloadSpeetTest.vue?vue&type=template&id=510d76ee"
import script from "./DownloadSpeetTest.vue?vue&type=script&lang=js"
export * from "./DownloadSpeetTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__